import HeroSlider from "../components/HeroSlider/HeroSlider";
import CountersSection from "../components/Counter/Counter";
import SkillsSection from "../components/SkillBar/SkillBar";
import EducationSection from "../components/Education/EducationSection";
import ExperienceSection from "../components/Timeline/ExperienceSection";
import BlogSection from "../components/Blog/BlogSection";
import ContactSection from "../components/ContactModal/ContactSection";
import {
  aboutText,
  specialties,
  achievements,
  projects,
} from "../data/portfolioData";

const HomeScreen = () => {
  return (
    <main>
      {/* Hero */}
      <HeroSlider />

      {/* About */}
      <section className="about-section" id="about">
        <div className="section-header">
          <span className="section-meta">About Us</span>
          <h2 className="section-title">Who Am I?</h2>
        </div>
        <div className="about-text">
          {aboutText.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        <div className="specialties-grid">
          {specialties.map((s) => (
            <div key={s.id} className={`specialty-card ${s.color}`}>
              <div className="specialty-icon">
                <i className={`fas ${s.icon}`}></i>
              </div>
              <h3>
                {s.title} {s.subtitle && <b>{s.subtitle}</b>}
              </h3>
            </div>
          ))}
        </div>
        <div className="hire-banner">
          <h2>
            I am happy to know you that 7 + big projects done sucessfully!
          </h2>
        </div>
      </section>

      {/* Achievements */}
      <section className="achievements-section" id="achievements">
        <div className="section-header">
          <span className="section-meta">What I do?</span>
          <h2 className="section-title">Here are some of my Achievements</h2>
        </div>
        <div className="achievements-grid">
          {achievements.map((a) => (
            <div key={a.id} className={`achievement-card ${a.color}`}>
              <div className="achievement-icon">
                <i className={`fas ${a.icon}`}></i>
              </div>
              <h3>{a.title}</h3>
              <p>{a.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Counters */}
      <CountersSection />

      {/* Skills */}
      <SkillsSection />

      {/* Education */}
      <EducationSection />

      {/* Experience */}
      <ExperienceSection />

      {/* Work */}
      <section className="work-section" id="work">
        <div className="section-header">
          <span className="section-meta">My Work</span>
          <h2 className="section-title">Recent Work</h2>
        </div>
        <div className="work-grid">
          {projects.map((p) => (
            <div key={p.id} className="work-card">
              <div
                className="work-card-bg"
                style={{ backgroundImage: `url(${p.image})` }}
              />
              <div className="work-card-overlay" />
              <div className="work-card-desc">
                <h3>
                  <a href={p.link} target="_blank" rel="noreferrer">
                    {p.title}
                  </a>
                </h3>
                <span>{p.subtitle}</span>
                <div className="work-card-icons">
                  {p.link !== "#" && (
                    <a href={p.link} target="_blank" rel="noreferrer">
                      <i className="fas fa-share-alt"></i>
                    </a>
                  )}
                  <a href="#work">
                    <i className="fas fa-eye"></i> {p.views}
                  </a>
                  <a href="#work">
                    <i className="fas fa-heart"></i> {p.likes}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Blog */}
      <BlogSection />

      {/* Contact */}
      <ContactSection />
    </main>
  );
};

export default HomeScreen;
